export default __webpack_public_path__ + "static/media/jcb.cd787ebb.svg";